export enum ROUTES {
  MAIN = '/',
  SUPPORT_CHATBOT = '/support-chatbot',
  CONTACT = '/contact',
  WIDGET = '/widget',
  WIDGET_ALL = '/widget/*',
  POST_LOGIN = '/post-login',
  CHATBOT_API = '/api/chatbot',
  WIDGET_API = '/api/widget',
  USER_ACTION = '/api/user-action',
  ARTICLES_SEARCH = '/api/search',
  CONTEXT = '/api/context',
  HELP_CENTER_SESSION = '/api/help-center-session',
  RESTART_CHAT = '/api/restart-chat',
  GET_LIVE_CHAT_MESSAGES = '/api/messages',
  MEDIA_TOKEN = '/api/media-token',
  MESSAGE_API = '/api/message',
  ARTICLE_API = '/api/article',
  ARTICLES_API = '/api/articles',
  CATEGORIES_API = '/api/categories',
  REQUEST_SUCCESS_MANAGER = '/api/request-success-manager',
  META_ARTIFACT_VERSION = '/meta/artifact-version',
}

export enum WIDGET_ROUTES {
  MODEL = '/model',
  INIT = '/init',
  RUNTIME = '/runtime',
  SESSION = '/session',
  HOMEPAGE = '/homepage',
  RECOMMENDED_ARTICLES = '/recommended-articles',
}

export enum CHATBOT_ROUTES {
  INIT = '/init',
  DEALER_OFFER = '/offer',
  SESSION = '/session',
  START_CHAT = '/start-chat',
}

export enum MESSAGE_ROUTES {
  MARK_AS_READ = '/mark-as-read',
}

export enum ARTICLE_ROUTES {
  ARTICLE_BY_ID = '/:id',
  ARTICLE_BY_URI = '/uri/:uri',
  VOTE = '/vote/:articleId',
  ARTICLE_VOTE = '/:articleId/vote',
}

export enum CATEGORY_ROUTES {
  CATEGORIES = '',
  CATEGORY_BY_URI = '/uri/:uri',
  ARTICLES_BY_CATEGORY = '/:categoryId/articles',
}

export enum EXTERNAL_ROUTES {
  INCIDENTS_TEST = 'https://apps.wix.com/answers-wix-integration/urgent-banner',
  INCIDENTS = 'https://status.wix.com/api/v2/incidents.json',
}

export enum ROUTES_WITH_REDIRECT {
  STATEMENT = '/statement',
}
